import ApiEndpointConstants from "../constans/ApiEndpointConstants";
import api from "./API";

// 后端：/api/add_or_update_message.php
export const add_or_update_message = (payload) => {
  return api.post(`${ApiEndpointConstants.ADD_OR_UPDATE_MESSAGE}`, {
    id: payload.id, // 可选，存在则更新
    user_id: payload.user_id, // 目标用户（必填：创建时）
    type: payload.type, // system | account | transaction | announcement
    title: payload.title,
    content: payload.content,
    priority: payload.priority, // 0普通 1重要 2紧急
  });
};


